<template>
  <div class="overlay-modal z-index-10" v-show="value">
    <div class="modal-content">
      <div class="modal-header">
        <button @click="closeModal" class="button default">X 閉じる</button>
      </div>
      <div class="modal-body">
        <iframe
          :id="iframeName"
          :src="iframeSrc"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowModaler',
  data () {
    return {
      showModalCurrent: true
    }
  },
  mounted () {
    this.showModalCurrent = true
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    iframeName: {
      type: String,
      required: true
    },
    iframeSrc: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeModal () {
//      this.$emit('update:showModal', false)
      this.$emit('input', false)
      document.querySelector('#' + this.iframeName).src = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShowModaler.vue